import React from 'react'
import { NavLink } from 'react-router-dom'
import { isActiveStyle, isNotActiveStyles } from '../utils/style'

const DBLeftSection = () => {
    return (
        <div className='absolute transform -translate-x-full md:translate-x-0 md:relative h-full py-12 flex flex-col bg-lightOverlay backdrop-blur-md shadow-md min-w-210 w-300 gap-3'>
            <NavLink to={"/dashboard"} className="flex items-center justify-start px-6 gap-4">
                Trang chủ
            </NavLink>
            <hr />

            <ul className='flex flex-col gap-4'>
                <NavLink
                    to={"/dashboard/home"}
                    className={({ isActive }) => 
                        isActive ? `${isActiveStyle} px-4 py-2 border-l-8 border-red-500` : isNotActiveStyles
                    }
                >
                    Trang chính
                </NavLink>
                <NavLink
                    to={"/dashboard/Items"}
                    className={({ isActive }) => 
                        isActive ? `${isActiveStyle} px-4 py-2 border-l-8 border-red-500` : isNotActiveStyles
                    }
                >
                    Các sản phẩm
                </NavLink>
                <NavLink
                    to={"/dashboard/orders"}
                    className={({ isActive }) => 
                        isActive ? `${isActiveStyle} px-4 py-2 border-l-8 border-red-500` : isNotActiveStyles
                    }
                >
                    Đơn hàng
                </NavLink>
                <NavLink
                    to={"/dashboard/newItem"}
                    className={({ isActive }) => 
                        isActive ? `${isActiveStyle} px-4 py-2 border-l-8 border-red-500` : isNotActiveStyles
                    }
                >
                    Thêm sản phẩm mới
                </NavLink>
                <NavLink
                    to={"/dashboard/users"}
                    className={({ isActive }) => 
                        isActive ? `${isActiveStyle} px-4 py-2 border-l-8 border-red-500` : isNotActiveStyles
                    }
                >
                    Danh sách tài khoản
                </NavLink>
            </ul>
        </div>
    )
}

export default DBLeftSection